import { useTranslation } from "react-i18next";
import InputForm from "../../../../../components/input/input-register/InputForm";
import PhoneNumberForm from "../../../../../components/input/input-register/PhoneNumberForm";
import SelectForm from "../../../../../components/input/input-register/SelectForm";

const AuthorizedRepresentativeContacts = ({
    containerClass,
    formRefs,
    profileData,
    handleChangeProfile,
    errorsProfileData,
    optionsPronounce,
    handleLiClickCountryList2,
    setProfileData,
}) => {
    const { t } = useTranslation();

    return (
        <div className={containerClass}>
            <p className="tw:!text-[18px] tw:!font-[600] tw:!text-[#282828] tw:!mb-2">
                {t("businessRegister.authorizedRepresentativeContacts.title")} <span className="tw:text-red-600">*</span>
            </p>
            <div className="tw:!flex tw:!flex-wrap tw:!gap-3 tw:!mb-3">
                <div className="tw:!w-full tw:md:!w-[calc(16.666667%-0.375rem)]">
                    <SelectForm
                        name={"contactHonorifics"}
                        suffixClass={"mb-0 fs-14"}
                        isSearchable={false}
                        options={optionsPronounce}
                        defaultValue={optionsPronounce[0]}
                        value={setProfileData.contactHonorifics}
                        onChange={(e) => setProfileData({
                            ...profileData,
                            contactHonorifics: e.value
                        })}
                        label={t("businessRegister.authorizedRepresentativeContacts.form.honorifics")}
                        placeholder={t("businessRegister.authorizedRepresentativeContacts.form.honorifics")}

                    />
                </div>
                <div className="tw:!w-full tw:md:!w-[calc(41.666667%-0.375rem)]">
                    <div className="tw:!flex-1">
                        <InputForm
                            innerRef={formRefs.contactFirstNameRef}
                            type={"text"}
                            suffixClass={"mb-0 fs-14"}
                            label={t("businessRegister.authorizedRepresentativeContacts.form.firstName")}
                            placeholder={t("businessRegister.authorizedRepresentativeContacts.form.firstName")}
                            id={"contactFirstName"}
                            name={"contactFirstName"}
                            value={profileData.contactFirstName}
                            onChange={handleChangeProfile}
                            isInvalid={errorsProfileData.contactFirstName}
                            invalidMessage={t(errorsProfileData.contactFirstName)}
                        />
                    </div>
                </div>
                <div className="tw:!flex-1">
                    <div className="tw:!flex-1">
                        <InputForm
                            innerRef={formRefs.contactLastNameRef}
                            type={"text"}
                            suffixClass={"mb-0 fs-14"}
                            label={t("businessRegister.authorizedRepresentativeContacts.form.lastName")}
                            placeholder={t("businessRegister.authorizedRepresentativeContacts.form.lastName")}
                            id={"contactLastName"}
                            name={"contactLastName"}
                            value={profileData.contactLastName}
                            onChange={handleChangeProfile}
                            isInvalid={errorsProfileData.contactLastName}
                            invalidMessage={t(errorsProfileData.contactLastName)}
                        />
                    </div>
                </div>
            </div>
            <div className="tw:!flex tw:!flex-wrap tw:!gap-3 tw:!mb-3">
                <div className="tw:!w-full tw:md:!w-[calc(58.333333%-0.375rem)]">
                    <InputForm
                        innerRef={formRefs.contactEmailRef}
                        type={"contactEmail"}
                        suffixClass={"mb-0 fs-14"}
                        label={t("businessRegister.authorizedRepresentativeContacts.form.email")}
                        placeholder={t("businessRegister.authorizedRepresentativeContacts.form.email")}
                        id={"contanctEmailAddress"}
                        name={"contactEmail"}
                        value={profileData.contactEmail}
                        onChange={handleChangeProfile}
                        isInvalid={errorsProfileData.contactEmail}
                        invalidMessage={t(errorsProfileData.contactEmail)}
                    />
                </div>
                <div className="tw:!w-full tw:md:!w-[calc(41.666667%-0.375rem)]">
                    <PhoneNumberForm
                        innerRef={formRefs.contactPhoneNumberRef}
                        suffixClass={"mb-0 fs-14"}
                        id="contactPhoneNumber"
                        name="contactPhoneNumber"
                        label={t("businessRegister.authorizedRepresentativeContacts.form.phoneNumber")}
                        placeholder={t("businessRegister.authorizedRepresentativeContacts.form.phoneNumber")}
                        countryCode={profileData.contactCountryCode}
                        prefixPhoneNumber={profileData.contactPrefixNumber}
                        value={profileData.contactPhoneNumber}
                        onClickCountryList={handleLiClickCountryList2}
                        onChange={handleChangeProfile}
                        isInvalid={errorsProfileData.contactPhoneNumber}
                        invalidMessage={t(errorsProfileData.contactPhoneNumber)}
                    />
                </div>
            </div>
        </div>
    );
};

export default AuthorizedRepresentativeContacts;
